import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
export default function Vacanze(){
  const [summary,setSummary]=useState<any|null>(null);
  const [planned,setPlanned]=useState<any[]>([]);
  useEffect(()=>{ Promise.all([ api.get('/LeaveDays/GetLeaveDays',{ params:{ ADATE: new Date().toISOString().slice(0,10) }}), api.get('/LeaveDays/GetPlannedEvents')]).then(([m,p])=>{ setSummary(m.data?.summary||null); setPlanned(p.data?.PlannedEvents||[]); }); },[]);
  return (<div><h2>Vacanze & Permessi</h2>{summary && <div>Ferie disponibili: {summary.ferieDisponibili}</div>}{planned.map((e:any)=>(<div key={e.id}>{e.description} — {e.status}</div>))}</div>);
}
